
import { Component, Vue, Prop, computed } from 'vue-property-decorator'
import { CreateHotTaskModal } from '@/components'
import FetchWrapper from '@/classes/fetchWrapper'

@Component({
  components: {
    CreateHotTaskModal
  }
})
export default class LearningVectorHistCard extends Vue {
  @Prop({ required: true })readonly id: number
  @Prop({ required: true })readonly userId: number
  @Prop({ required: true })readonly createdAt: Date
  @Prop({ required: true })readonly expireAt: Date
  @Prop({ required: true })readonly usedDates: Array
  @Prop({ required: true })readonly lastUsedDate: Date
  @Prop({ required: true })readonly isActive: boolean
  @Prop({ required: true })readonly keyword: string
  @Prop({ required: true })readonly description: string
  @Prop({ required: true })readonly subject: string
  @Prop({ required: true })readonly intention: string
  @Prop({ required: true })readonly level: string
  @Prop({ required: true })readonly category: string
  @Prop({ required: true })readonly taskTypes: string[]
  @Prop({ required: true, default: true })readonly canRemove: boolean
  @Prop({ required: true, default: true })readonly canCreateTask: boolean

  data () {
    return {
      isNewTaskModalOpen: false,
      isLoading: false
    }
  }

  get isLoggedIn () {
    return this.$store.state.loggedIn
  }

  async openNewTaskModal () {
    this.isNewTaskModalOpen = true
  }

  createdNewTask (taskId) {
    this.$buefy.dialog.confirm({
      title: 'Go to task',
      message: 'Do you wanna go to task page?',
      onConfirm: () => {
        window.location.href = `/home/task/${taskId}`
      },
      canCancel: true
    })
  }

  askToRemove () {
    this.$buefy.dialog.confirm({
      title: 'Remove Learning Vector',
      message: 'Are you sure to remove? You would not be able to recover it back.',
      onConfirm: this.remove,
      canCancel: true
    })
  }

  async remove () {
    try {
      this.isLoading = true

      var resp = await FetchWrapper.get(`${process.env.VUE_APP_SERVERURL}/deactivateLearningVectorHist/${this.userId}/${this.id}`)

      this.isLoading = false
      if (resp.error) {
        this.$buefy.dialog.confirm({
          title: 'Error',
          message: resp.error,
          canCancel: false
        })
      } else {
        this.$buefy.dialog.confirm({
          title: 'Success',
          message: 'Learning Vector removed successfully',
          onConfirm: () => {
            this.$emit('removed', resp.id)
          },
          canCancel: false
        })
      }
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Something went wrong. ${e}`,
        canCancel: false
      })
    }
  }
}
